module.exports = __webpack_public_path__ + "img/5_92.5678dbba.png";